{
	"id": 7819578,
	"numericId": 7819578,
	"collectionId": 788,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 103727,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "The Professional Educator and Technology",
					"summary": "This module contains two activities and a five-question end-of-module knowledge check. It will take approximately 30 to 40 minutes to complete the entire module.",
					"moduleNumber": 6,
					"activityCount": 2,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 35
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"items": [
								{
									"icon": "circle-play",
									"title": "Video"
								},
								{
									"icon": "messages-square",
									"title": "Perspectives"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Review"
								},
								{
									"icon": "chart-column-increasing",
									"title": "Analysis"
								}
							],
							"title": "Scenario: Good Intentions, Hidden Risks"
						},
						{
							"title": "Ethical Situations: What Could Possibly Happen?"
						},
						{
							"title": "Module 6 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Analyzing a scenario to differentiate how dispositional and regulatory frameworks influence decision making and determining an appropriate course of action",
						"Recognizing how well-intentioned uses of technology can create ethical risks",
						"Applying ethical decision making in technology-based situations",
						"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve technology-based ethical scenarios",
						"Identifying professional boundaries related to digital communication"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 6010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103728,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving ethical decisions that educators encounter as they interact with students in challenging emotional situations.\n\nFirst, you will review a video that shows the interactions between educators, a student, and a parent. Then, you will gain further insight by reviewing three videos showing the perspectives of people involved in the scenario. After observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Good Intentions, Hidden Risks",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_scenario.mp4",
						"transcript": "**Good Intentions, Hidden Risks**\n\nThe video shows five scenes which include a teacher (Mr. Gaul), a principal (Mr. Dominguez), a counselor (Ms. Park), a student (Noah), and a parent (Ms. Harris).\n\nThe first scene takes place in Principal Dominguez’ office. The banner on the video states “Principal Dominguez’s Office: Early Monday Morning.”\n\nPrincipal Dominguez: Mr. Gaul, thank you for coming in so early. You know Ms. Park, our school counselor.\n\nMr. Gaul: Of course. Hi, Ms. Park.\n\nPrincipal Dominguez: As you may have heard, a student, Jake, passed away unexpectedly last night. This is a traumatic situation for our school community.\n\nMr. Gaul: I heard. It’s heartbreaking. The students are already talking about it.\n\nPrincipal Dominguez: That’s why we need to be very intentional in our response. We’re particularly concerned about Jake’s best friend, Noah.\n\nMs. Park: Noah is in your class, and his parents have shared that he considers you to be a trusted adult at school.\n\nPrincipal Dominguez: While the school crisis-response plan is being activated, we want to make sure Noah is supported during the school day.\n\nMr. Gaul: Sure. I’m happy to help you. I’ll check in with Noah today.\n\nThe video now shows the second scene, which takes place later that day in Mr. Gaul’s classroom. The banner on the video states “Mr. Gaul’s Classroom: Later That Day.”\n\nMr. Gaul: Noah, do you have a moment? I know today has been really hard. I want you to know that there are people here to support you.\n\nNoah: I just don’t understand what happened.\n\nMr. Gaul: What you’re feeling makes sense. If you want, you can talk with the counselor. She’s trained to help in situations like this.\n\nNoah: I don’t know right now.\n\nMr. Gaul: If you ever feel overwhelmed, you can reach out to me. Here’s my cell phone number.\n\n[Mr. Gaul gives Noah a handwritten copy of his cell phone number.]\n\nThe video then shows the third scene, which shows Noah in his bedroom and a text-message exchange between him and Mr. Gaul. The banner on the video states “Noah’s Bedroom: One Day Later in the Evening.”\n\nMr. G: 9:04 p.m.: Just checking in. How are you doing tonight?\n\nNoah: 9:08 p.m.: Still sad. Trying to focus on homework.\n\nMr. G: 9:20 p.m.: Make sure you’re getting rest. Remember, I’m available to talk any time before or after school if you want to stop by the classroom.\n\nNoah: 9:50 p.m.: Thanks. Can I call now?\n\nMr. G: 9:55 p.m.: Sure.\n\nNoah: 10:30 p.m.: Thanks again.\n\nNoah: 11:30 p.m.: You awake? Guess not. I’ll come by in the morning.\n\nThe video now shows the fourth scene, which takes place at Noah’s house. Noah and his mom, Ms. Harris, are preparing to watch a movie. Noah unlocks his phone and walks away. The phone receives notifications, and Noah’s mom picks it up and scrolls through many messages. The banner on the screen states “Noah’s House: One Week Later on a Weekend Evening.”\n\nMs. Harris: Noah, who is Mr. G?\n\nNoah: He’s my history teacher.\n\n[Ms. Harris’ expression shifts from confusion to alarm.]\n\nThe video then shows the fifth scene, which takes place in Principal Dominguez’ office. Principal Dominguez is talking to Ms. Harris on speakerphone. Ms. Harris is angry. The banner on the video states “Principal Dominguez’s Office: Monday Afternoon.”\n\nMs. Harris: This is completely inappropriate. A teacher should not be privately texting and calling my child late at night and on weekends.\n\nPrincipal Dominguez: I hear your concern, Ms. Harris, and I take it seriously. I will look into this immediately.\n\n[The video ends.]",
						"transcriptTitle": "Transcript for Good Intentions, Hidden Risks video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "Scenario: Good Intentions, Hidden Risks",
				"instruction": "**Directions:** Review the following video to learn about the scenario. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 6020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103729,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "A parent appreciates the flexibility, but the district’s IT department flags the use of nonapproved platforms and reminds Ms. Albert that these communications must be archived according to policy."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "A sibling joins a parent-teacher conference through a link found on a shared electronic device. The sibling hears confidential student information."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "A family without a smartphone feels excluded and raises equity concerns about inconsistent access to conferencing options."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "To support families with limited time to attend school conferences, Ms. Albert offers to conduct parent‑teacher conferences using whatever communication apps parents already have, even though the platforms are not district approved. She is aware that families’ access to devices and internet connectivity varies widely.",
					"title": "Situation 1: Parent-Teacher Conference",
					"number": 1,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 8,
				"sourceId": 6080
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103730,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Mr. Dickinson relies on an unreliable plagiarism‑checking program that he did not verify the source of. Because of this, Mr. Dickinson incorrectly penalizes a student."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "While meeting with a student about their draft paper, a student admits to Mr. Dickinson about using an AI writing tool without understanding citation rules, prompting a conversation about digital literacy and intellectual property."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "After researching and conducting appropriate searches, Mr. Dickinson determines that a student’s writing genuinely improved, allowing him to grade with accuracy and fairness."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "While grading high school students’ essays, Mr. Dickinson notices sudden improvements in several students’ writing that do not align with their previous work. He wonders if students may have used online sources or AI‑generated content without proper citation. He is unsure how to check on this effectively while also ensuring he respects students’ creativity and intellectual property.",
					"title": "Situation 3: Progress or Plagiarism",
					"number": 3,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 10,
				"sourceId": 6100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103731,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "",
				"items": [
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_mr_gaul.png"
							}
						],
						"title": "Mr. Gaul, Teacher",
						"analysis": {
							"text": "Mr. Gaul acted with care and concern and on his personal belief that trusted relationships are essential during crisis situations. However, he gradually moved beyond the scope of his training and professional role, particularly by engaging in private communication with a student after school. While his intentions aligned with an ethic of care, they conflicted with ethical standards related to boundaries, technology use, and role limitations.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions Mr. Gaul could ask himself.\n- Am I responding based on what feels caring or on what my role and training authorize me to do?\n- How might the student’s family or the broader school community interpret my communication choices?\n- At what point does helping cross into providing support that I am not trained to give?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Caring for students does not mean doing everything yourself.** Ethical responsibility means knowing when to listen, when to refer, and when to stop, even if your intentions are good.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_ms_park.png"
							}
						],
						"title": "Ms. Park, School Counselor",
						"analysis": {
							"text": "The counselor’s perspective is grounded in professional training, specialized competence, and system‑level accountability. She recognizes that unstructured support, especially through digital communication, increases risk for both students and educators. Her concerns center on student safety, appropriate intervention, and maintaining transparency, which is achieved through shared responsibility, not private action.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions Ms. Park could ask herself.\n- How can I ensure that teachers understand the limits of their role during crises?\n- What proactive steps can help prevent boundary confusion before harm occurs?\n- How can I support empathetic teachers while reinforcing ethical standards?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Expertise matters in ethical decision making.** When situations exceed your training, ethical responsibility means involving professionals equipped to respond safely and appropriately.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_principal_dominguez.png"
							}
						],
						"title": "Principal Dominguez",
						"analysis": {
							"text": "The principal balances considerations related to urgency, public trust, and institutional responsibility. While it is important to recognize the value of relationships with trusted adults, the principal must ensure that responses to crises follow policy, protect students, and uphold professional norms. From this perspective, lapses in judgment, especially involving technology, carry ethical, legal, and reputational consequences for the entire school community.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions Principal Dominguez could ask himself.\n- Were expectations about boundaries and communication made explicit during the crisis?\n- How can leadership better help staff understand ethical boundaries?\n- What systems need strengthening to prevent similar situations in the future?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Ethical decisions exist within systems, not in isolation.** Even well‑intentioned actions can cause harm when they bypass policy, training, and oversight.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "Scenario: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs to review feedback on Mr. Gaul’s, Ms. Park’s, and Principal Dominguez’ involvement in the scenario. Select each of the expandable text buttons within each tab to review the information about each person."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 7,
				"sourceId": 6070
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103732,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following three videos showing the perspectives of Mr. Gaul, Ms. Park, and Principal Dominguez.",
				"items": [
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_perspective_mr_gaul.mp4",
							"transcript": "**Mr. Gaul’s Reflection**\n\nThe video shows Mr. Gaul reflecting while standing in his classroom.\n\nMr. Richard Gaul: The principal and the counselor acknowledged that Noah trusted me. That mattered to me. I believed that trust came from my role as a professional educator, someone trained to support students and someone who cares about their well-being. I didn’t see myself replacing the counselor, but as being present in a moment when an adult connection felt critical.\n\nI was worried about what would happen if I didn’t reach out to Noah. I told myself that checking in, answering a text, or taking a call was part of being a caring professional. I wasn’t thinking about time, boundaries, or how those messages might seem to others. I was focused on one student and what I believed he needed in that moment.\n\nLooking back, I can see that I underestimated how quickly professional boundaries can blur, especially when technology makes communication so easy. I believed I was acting in Noah’s best interest, but I didn’t stop to consider whether my actions stayed within my role, followed my training, and adhered to our ethical obligations as educators.",
							"transcriptTitle": "Transcript for Mr. Gaul video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Mr. Gaul"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_perspective_ms_park.mp4",
							"transcript": "**Ms. Park’s Reflection**\n\nThe video shows Ms. Park reflecting while sitting at her desk.\n\nMs. Kathryn Park: Teachers play a vital role in noticing changes in students’ behavior, offering empathy to students during the school day, and referring students for additional support. But when our professional and personal lines blur, the student may become dependent on someone who is not trained to assess risk or provide ongoing crisis intervention.\n\nMy focus is always on maintaining clear boundaries so students receive the right help from the right people and so educators are protected as well.",
							"transcriptTitle": "Transcript for Ms. Park video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Ms. Park"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-6/m6_perspective_principal_dominguez.mp4",
							"transcript": "**Principal Dominguez’ Reflection**\n\nThe video shows Principal Dominguez reflecting while sitting at his desk.\n\nPrincipal Dominguez: I understand why Mr. Gaul felt compelled to help. He was identified as a trusted adult. And that trust is an asset in the school community. But trust does not remove the need for clear roles, specialized training, or policy compliance, especially when technology is involved.\n\nWhen communication extends into private texts, late evenings, and weekends, it creates ethical, legal, and reputational risks for everyone involved. Even well-intentioned actions can undermine public trust if they occur outside approved systems subject to oversight.",
							"transcriptTitle": "Transcript for Principal Dominguez video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Principal Dominguez"
					}
				],
				"title": "Scenario: Perspectives",
				"instruction": "**Directions:** Select each of the following three tabs to review the three perspective videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_resource_set",
				"language": "en-US",
				"position": 3,
				"sourceId": 6030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103733,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Scenario: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Mr. Gaul? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 5,
				"sourceId": 6050
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "abd8e46c-3936-4f3a-a8f0-f42ba6404cd8",
						"isCorrect": true
					},
					{
						"choiceId": "60633681-bd86-4b40-a6cc-afdb4bbdcddc",
						"isCorrect": true
					},
					{
						"choiceId": "08773607-194b-4265-801b-17c63136c915",
						"isCorrect": true
					},
					{
						"choiceId": "86d2d7ba-48ee-4f21-8901-c716e427c5a3",
						"isCorrect": true
					},
					{
						"choiceId": "35123be7-2986-48bd-a5f5-6b4b42089df1",
						"isCorrect": true
					},
					{
						"choiceId": "c12e58c4-10a9-4e97-917a-ef62b6f28a89",
						"isCorrect": true
					},
					{
						"choiceId": "d2872a7d-5e2c-4cb5-9706-e15792725e49",
						"isCorrect": true
					},
					{
						"choiceId": "c429eec1-3df5-4dc8-91f0-e0bd20ec0f52",
						"isCorrect": true
					},
					{
						"choiceId": "ab98ddf0-477a-46c1-9177-c2e0b91d0743",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "abd8e46c-3936-4f3a-a8f0-f42ba6404cd8",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "60633681-bd86-4b40-a6cc-afdb4bbdcddc",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "08773607-194b-4265-801b-17c63136c915",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "86d2d7ba-48ee-4f21-8901-c716e427c5a3",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "35123be7-2986-48bd-a5f5-6b4b42089df1",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "c12e58c4-10a9-4e97-917a-ef62b6f28a89",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "d2872a7d-5e2c-4cb5-9706-e15792725e49",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "c429eec1-3df5-4dc8-91f0-e0bd20ec0f52",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "ab98ddf0-477a-46c1-9177-c2e0b91d0743",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103734,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Mr. Gaul’s decisions regarding his interactions with Noah.",
				"title": "Scenario: Reflect",
				"question": "Was Mr. Gaul influenced more by his dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 4,
				"sourceId": 6040
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "411ea56e-5d1d-4e66-b0d0-352f4e488508",
						"isCorrect": true
					},
					{
						"choiceId": "b8f7d2df-98f4-496d-b1a4-38d44744c78e",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "411ea56e-5d1d-4e66-b0d0-352f4e488508",
					"detailed": {
						"text": "Mr. Gaul was influenced more by his dispositional framework than by the regulatory framework. His decisions were guided by personal beliefs about caring for students, being a trusted adult, and responding compassionately in a crisis, rather than by close attention to school policies or professional boundaries governing communication and role limitations. While his intentions aligned with values of care and support, relying primarily on disposition led him to overlook regulatory expectations that should have constrained how, and when, he communicated with Noah."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "b8f7d2df-98f4-496d-b1a4-38d44744c78e",
					"detailed": {
						"text": "If Mr. Gaul had been influenced more strongly by the regulatory framework, he would have based his decisions on school and district policies, clearly defined role expectations, and established protocols for crisis response and electronic communication. Instead of engaging in private texting and communicating outside school hours, he would have limited his interactions with Noah to appropriate school settings, documented concerns, and referred Noah to trained mental‑health professionals in accordance with policy. The regulatory framework would have helped him recognize that professional boundaries around time, place, communication, and training exist to protect both students and educators, even in emotionally urgent situations."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "411ea56e-5d1d-4e66-b0d0-352f4e488508",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "b8f7d2df-98f4-496d-b1a4-38d44744c78e",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103735,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Mr. Gaul.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Gaul becomes focused on the needs of a single student when trying to help Noah. He also blurs the scope of his position with that of more expansive roles such as counselor, confidant, caregiver, and rescuer."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "The best of intentions can often put an educator at risk. In this case, two factors contribute to Mr. Gaul’s misinterpretation of what his professional role allows: his compassionate response and unclear expectations from administration as to how he should support Noah. Additionally, Mr. Gaul did not communicate with Noah’s parent. All this causes the risk of serious allegations."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "There is always the risk that caring educators become focused on the needs of a single student. When that occurs, objectivity and neutrality may be at risk."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "To mitigate risk to student welfare, it is important that educators defer to those who are most trained to assist students. In this case, Mr. Gaul is acting in a role that he is not trained for."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Since the school’s administrative team and the student’s mother were not aware of the private conversations between Mr. Gaul and Noah until after the conversations happened, the concept of transparency is at immediate risk."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "By not adhering to the expectations of the teacher-student role, the boundaries of role, time, and place are at immediate risk."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Regardless of the purity of the intent, any perception of ill intention places the integrity of the profession at risk. Phone calls and text messages at night between students and teachers may be interpreted as the markers of a profession without clear boundaries."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "There are many standards within the *MCEE* that provide guidance as to how Mr. Gaul and other school employees can best handle sensitive student care. If an educator does not consult a set of collective standards valued by the profession, this principle is at risk."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Scenario: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Mr. Gaul. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 6,
				"sourceId": 6060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103736,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "A parent complains after their child encounters an inappropriate image because Mr. Brown bypassed district-provided filtering tools."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Ms. Chapel speaks with Mr. Brown, and Mr. Brown realizes he needs updated training on the district’s instructional technology tools."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The technology department launches a review of teacher device logs to ensure compliance with content‑filtering and monitoring procedures."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Ms. Chapel teaches across the hall from Mr. Brown’s middle school art class. She notices that students occasionally open online resources that may not be appropriate. She also observes that Mr. Brown sometimes bypasses district‑provided filtering tools because he believes they are too restrictive.",
					"title": "Situation 2: Age-Appropriate Internet Content",
					"number": 2,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 9,
				"sourceId": 6090
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103737,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Students with private accounts feel that their privacy was violated when Mr. Lee publicly shared their posts, even though it was for instructional purposes."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "A student becomes the target of online harassment outside school hours, raising questions about the teacher’s duty to monitor risks associated with class‑related online activities."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Parents object to their children being required to open social media accounts, citing privacy and safety concerns."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Mr. Lee, a high school teacher, designs a digital-literacy unit requiring students to create social media profiles so they can analyze online communication. He follows each student account and evaluates their activity. He shares selected example posts publicly to highlight strong digital citizenship, even though some students have set their accounts to private.",
					"title": "Situation 6: Digital-Literacy Lesson",
					"number": 6,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 13,
				"sourceId": 6130
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103738,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "A parent recognizes a story about their child, despite the lack of names, and files a complaint about a breach of confidentiality."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "The principal worries that community trust may be destroyed and asks Ms. Howe to revise episodes to remove identifiable details."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "A central office administrator tells Ms. Howe that having the podcast may violate professional boundaries around electronic communication agreed to in the district social media policy."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "In her free time, Ms. Howe, an elementary teacher, produces a podcast about the joys and challenges of teaching in a small, rural school district. Listeners enjoy her humor and insight, but some parents and colleagues express concern that her stories, even when names are omitted, contain enough detail to identify individuals.",
					"title": "Situation 7: Teacher Podcast",
					"number": 7,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 14,
				"sourceId": 6140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103739,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "The community organization shares the presentation publicly, accidentally revealing the names of students."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "The district informs Mr. Ingram that he must follow formal procedures for external fundraising and protect student information."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The organization offers to partner with the school but asks for photos of specific students to share on their website, prompting a discussion about media permissions and appropriate data sharing."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Mr. Ingram, a high school teacher, teaches in a district that does not supply each student with a digital device. He is unsure how to advocate for equitable access to technology while protecting confidentiality and following the district’s fundraising procedures. He creates a presentation for a local community organization highlighting the limitations of sharing devices and includes pictures of his students using shared equipment. He also includes the names of his students.",
					"title": "Situation 8: Requesting Technology",
					"number": 8,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 15,
				"sourceId": 6150
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103740,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Administrators review the archived email history and work with Mr. Edgar to prepare an appropriate response to the complaint."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Mr. Edgar tries to delete the messages. The IT department restores the deleted emails from backup and reminds Mr. Edgar about the importance of record retention."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The district’s legal team identifies statements that may be misinterpreted because of their emotional tone or lack of clarity, prompting training on professional electronic communication."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Mr. Edgar has exchanged increasingly tense emails with a parent about a student’s support plan. The parent files a formal complaint, and Mr. Edgar becomes concerned that some of his messages might be misinterpreted.",
					"title": "Situation 4: Contentious Emails",
					"number": 4,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 11,
				"sourceId": 6110
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103741,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Community members raise concerns that Ms. Fern’s public posts blur personal and professional boundaries, prompting an HR review of staff social media guidelines."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Students begin following her account, and the district advises her to create clear separations between her personal and professional profiles."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Parents come to a school board meeting to complain about Ms. Fern’s photos and to ask that she be sanctioned."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Ms. Fern, a K–8 physical education teacher, maintains a personal social media account where she documents her fitness journey. Her posts include workout photos, commentary about training, and promotions of fitness attire and wellness products. Her account reaches a large audience. Some parents praise her dedication; others worry that the visibility of her personal content may blur professional boundaries.",
					"title": "Situation 5: Social Media Stardom",
					"number": 5,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 12,
				"sourceId": 6120
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103742,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Yaz receives a request from a current student to connect on a social networking site.\n\nWhich of the following considerations is most important for Ms. Yaz in maintaining appropriate professional boundaries and ethical responsibilities?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 20,
				"sourceId": 6200
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "b92a1a9e-d385-4a20-a973-76b0c43acd6f",
						"isCorrect": true
					},
					{
						"choiceId": "e86053e2-3225-45a0-b8ee-cdcc06bfe3fb",
						"isCorrect": false
					},
					{
						"choiceId": "fd3ad298-6da6-49df-8f26-a513fbfe624f",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "b92a1a9e-d385-4a20-a973-76b0c43acd6f",
					"detailed": {
						"text": "Interactions on social media can blur the line between personal and professional roles; therefore, educators must ensure that their communications remain professional, transparent, and consistent with school policies. Careful attention to these boundaries helps protect both the student and the educator and minimizes the risk of situations that could be perceived as inappropriate or unprofessional."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "b92a1a9e-d385-4a20-a973-76b0c43acd6f",
						"text": "The significance of ensuring communication with students remains consistent with school policies",
						"numFirstSelections": 0
					},
					{
						"id": "e86053e2-3225-45a0-b8ee-cdcc06bfe3fb",
						"text": "The potential benefits of using social media to support communication with students",
						"numFirstSelections": 0
					},
					{
						"id": "fd3ad298-6da6-49df-8f26-a513fbfe624f",
						"text": "The student’s intent in sending the social media connection request to their teacher",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103743,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Students begin receiving targeted ads and notifications that align with the sensitive data they uploaded to the app, alarming families."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Some students feel pressured to use the app and report discomfort with sharing personal information digitally."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The district’s technology team discovers that the app does not meet student data‑privacy standards and directs Ms. Jarvis to discontinue use of the app with her students."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Ms. Jarvis, a health teacher, introduces a unit on personal wellness and encourages students to try a popular health‑tracking app. The app collects sensitive personal data, and shares generalized data with third‑party advertisers. Some students are uncomfortable, and parents raise questions about data privacy.",
					"title": "Situation 9: Health-Tracking App",
					"number": 9,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 16,
				"sourceId": 6160
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103744,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: What Could Possibly Happen?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Because the syncing error exposes students’ activity data, the district leads an investigation into cybersecurity practices."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Students use the app’s chat feature to tease and exclude peers, which goes unnoticed by Mr. Kilburn for several weeks. Mr. Kilburn takes the fitness-tracking devices back, tells students to stop using the app, and meets with administration to address the cyberbullying."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "A parent requests access to all digital records associated with their child, prompting a review of how the data was stored, shared, and secured."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "To encourage physical activity, Mr. Kilburn, a middle school physical education teacher, provides wearable fitness-tracking devices for his students and asks them to upload weekly data to a shared spreadsheet. The devices link to an app with social features such as leaderboards and messaging. After six weeks, a data‑syncing error exposes some students’ activity data publicly.",
					"title": "Situation 10: Fitness Tracker",
					"number": 10,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 17,
				"sourceId": 6170
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103745,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**Why Ethical Judgment Involving Technology Matters in Everyday Situations**\n\nTechnology is part of nearly every aspect of modern teaching, from communicating with students and families to designing instruction, assessing learning, and advocating for student support. Because digital tools remove traditional limits on time, place, and visibility, everyday decisions can quickly carry ethical weight. What may feel like responsiveness, flexibility, or care can unintentionally create risk when professional boundaries are not clearly maintained.\n\nThis module demonstrated that ethical challenges involving technology rarely arise from malicious intent. Instead, they often develop through well‑intentioned choices made under pressure, especially during moments of crisis, urgency, or emotional need. Without careful ethical judgment, small decisions (such as how, when, or where communication occurs) can escalate everyday situations into ethical dilemmas that concern transparency, role confusion, student welfare, and public trust.\n\n**Key Ethical Standards Addressed in This Module**\n\nThroughout Module 6, you examined how ethical standards guide professional behavior when technology is involved. Central to this work was understanding the balance between dispositional decision making (that is, when decisions are influenced by personal values, empathy, and care) and regulatory decision making (that is, when decisions are influenced by policies, laws, and professional standards). Ethical practice requires both, but neither can stand alone.\n\nThe module emphasized ethical principles aligned with the *Model Code of Ethics for Educators*, including the following concepts.\n- Maintaining transparency in actions and communications\n- Mitigating professional and personal risk\n- Preserving objectivity and neutrality\n- Ensuring student welfare\n- Honoring the boundaries of role, time, and place\n- Upholding the integrity of the profession\n\nBy analyzing a scenario and situations involving digital communication, social media, instructional technology, and data privacy, you saw how technology can place multiple ethical principles at risk simultaneously and that professional standards exist to protect students, educators, and school communities.\n\n**Applying Ethical Decision Making in Your Own Practice**\n\nAs a beginning educator, developing ethical habits now is critical. This module reinforced that ethical decision making is not about finding perfect answers, but about pausing, reflecting, and using shared standards to guide action, especially when technology is involved.\n\nApplying what you learned means recognizing when a situation exceeds your role or training, knowing when to refer concerns to appropriate professionals, and understanding that ethical responsibility often involves restraint rather than increased involvement. It also means anticipating how digital actions might be perceived by students, families, colleagues, administrators, and the broader community.\n\n**Ethical use of technology requires professional judgment grounded in shared standards, not just care or convenience.**\n\nEthical professionalism in the digital world depends on clear boundaries, informed judgment, and fidelity to shared ethical standards. By practicing ethical reflection consistently, you strengthen your effectiveness, protect student well‑being, and contribute to the long‑term trust placed in the teaching profession.",
				"title": "Module 6 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 18,
				"sourceId": 6180
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103746,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Nikos and Mr. Kowalski, who are sixth-grade math teachers, are talking in the teachers’ lounge. Ms. Nikos tells Mr. Kowalski that she has come across a website that provides an online fraction calculator. She mentions that she is thinking about using the site during class as a learning tool for her students.\n\nWhich of the following should Ms. Nikos consider in order to best honor the principle of respecting intellectual property?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 19,
				"sourceId": 6190
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "f8c93993-5e4e-4a74-a981-ae09c78ee780",
						"isCorrect": false
					},
					{
						"choiceId": "d0ba5c2c-62f4-4598-9d47-c6d2d3dc1465",
						"isCorrect": true
					},
					{
						"choiceId": "9b3bc9f9-588a-438a-96d3-8f0602058594",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "d0ba5c2c-62f4-4598-9d47-c6d2d3dc1465",
					"detailed": {
						"text": "While many educational websites are free for private individual use, they may require a license or fee to be used commercially or in a classroom setting. Ms. Nikos should carefully check the site's fine print to avoid a potential copyright violation."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "f8c93993-5e4e-4a74-a981-ae09c78ee780",
						"text": "Whether using calculators could impede students’ learning of core concepts",
						"numFirstSelections": 0
					},
					{
						"id": "d0ba5c2c-62f4-4598-9d47-c6d2d3dc1465",
						"text": "Whether such free use of the website has been licensed by the site owner",
						"numFirstSelections": 0
					},
					{
						"id": "9b3bc9f9-588a-438a-96d3-8f0602058594",
						"text": "Whether the website displays ads that may be inappropriate for students",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103747,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Lavery, a school counselor, is planning to enroll certain students from her school in a community-wide honors organization and wants to submit their GPA information to the organization.\n\nWhich of the following best describes the main concern with Ms. Lavery’s plan?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 22,
				"sourceId": 6220
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "57f1bd40-4250-45c7-a372-04c1d97de613",
						"isCorrect": false
					},
					{
						"choiceId": "34ff41b2-e2bd-46a9-af79-82562b863083",
						"isCorrect": true
					},
					{
						"choiceId": "93e9dc26-e11a-4d7d-8786-062fa7f95a35",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "34ff41b2-e2bd-46a9-af79-82562b863083",
					"detailed": {
						"text": "Even though Ms. Lavery intends to help students by enrolling them in an honors organization, sharing students’ GPA information without proper consent may violate laws and policies that protect student privacy. Educators must follow rules for handling confidential information, even when their intentions are positive."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "57f1bd40-4250-45c7-a372-04c1d97de613",
						"text": "It is an unfair practice to select only some students for honors consideration.",
						"numFirstSelections": 0
					},
					{
						"id": "34ff41b2-e2bd-46a9-af79-82562b863083",
						"text": "Sharing student information without parental consent may violate the students’ rights to confidentiality.",
						"numFirstSelections": 0
					},
					{
						"id": "93e9dc26-e11a-4d7d-8786-062fa7f95a35",
						"text": "Schools should only share student information with organizations that are directly affiliated with the school district.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103748,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Miller, an English teacher, leads a professional development workshop to show colleagues how to use an online service that checks student writing for plagiarism. He points out that while the service is typically accurate, in certain cases, student work can be incorrectly flagged as plagiarized if it contains a large amount of quoted material from sources.\n\nMr. Miller is most directly honoring which of the following ethical principles?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 23,
				"sourceId": 6230
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "69518e25-199b-4fc3-90f5-dcff76960872",
						"isCorrect": true
					},
					{
						"choiceId": "0c9d47e3-2dbd-4987-859e-3988b394557d",
						"isCorrect": false
					},
					{
						"choiceId": "eb9c685a-52fa-479c-b5db-814d6b48f77b",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "69518e25-199b-4fc3-90f5-dcff76960872",
					"detailed": {
						"text": "Mr. Miller is helping colleagues understand that the plagiarism detection tool is not perfect and may sometimes flag student work incorrectly. By explaining its limitations, he ensures that the tool is used responsibly and that students are not unfairly accused of plagiarism."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "69518e25-199b-4fc3-90f5-dcff76960872",
						"text": "Clarifying the limitations of various technological applications",
						"numFirstSelections": 0
					},
					{
						"id": "0c9d47e3-2dbd-4987-859e-3988b394557d",
						"text": "Considering the implications of sharing sensitive information electronically",
						"numFirstSelections": 0
					},
					{
						"id": "eb9c685a-52fa-479c-b5db-814d6b48f77b",
						"text": "Understanding district policies on using technology appropriately",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103749,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Ivanov, a grade school teacher, receives a forwarded message from a colleague in her work e-mail account. When Ms. Ivanov opens the message, she sees that it contains inappropriate and offensive material.\n\nIn determining how to respond to this incident, which of the following principles for professional educators is most important for Ms. Ivanov to consider?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 21,
				"sourceId": 6210
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "46f17a73-7828-46a7-92bc-c2922808597f",
						"isCorrect": false
					},
					{
						"choiceId": "feca3066-b364-485d-91bd-6df548e911b2",
						"isCorrect": false
					},
					{
						"choiceId": "acad8e1b-9845-44d1-8c01-2d15a431e20a",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "acad8e1b-9845-44d1-8c01-2d15a431e20a",
					"detailed": {
						"text": "Professional educators have an ethical responsibility to recognize, address, and report inappropriate materials or conduct that violates professional standards. Failing to respond to such incidents may allow unprofessional behavior to continue and can undermine the integrity of the educational environment. By addressing and reporting the inappropriate content, Ms. Ivanov helps uphold professional expectations, protect the school community, and promote a safe and respectful learning environment."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "46f17a73-7828-46a7-92bc-c2922808597f",
						"text": "The obligation to ensure that the rights to privacy of colleagues and students are respected",
						"numFirstSelections": 0
					},
					{
						"id": "feca3066-b364-485d-91bd-6df548e911b2",
						"text": "The duty to address concerns with colleagues in a professional and respectful manner",
						"numFirstSelections": 0
					},
					{
						"id": "acad8e1b-9845-44d1-8c01-2d15a431e20a",
						"text": "The responsibility to identify, address, and report inappropriate materials and conduct",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37092,
					"label": "Module 6: The Professional Educator and Technology",
					"title": "Module 6: The Professional Educator and Technology",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 6: The Professional Educator and Technology",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "b8639bc9-1db9-42c8-946b-44bbd8f3970d",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
